import Swiper, { Pagination } from 'swiper';

const ProductStyles = function () {
  
    // configure Swiper to use modules
    Swiper.use( Pagination );
    const els = document.querySelectorAll( '.swiper-product-styles' );

    // loop through swiper sections and init Swiper
    if ( Object.keys(els).length ) {
        els.forEach( function( el ){
            const pagination = el.querySelector( '.swiper-pagination');
            const swiper = new Swiper( el , {
            direction: 'horizontal',
            spaceBetween: 12,
            slidesPerView: 'auto',
            initialSlide: 0,
            loop: false,
            breakpoints: {
                992: {
                slidesPerView: 4,
                centeredSlides: false,
                allowTouchMove: false,
                }
            }
            })
        });
    }

    // Collapse list if more than 5 items
    let productStyles = document.querySelectorAll('.swiper-slide__list');
    productStyles.forEach(list => {
        let itemsArray = [];
        let items = list.querySelectorAll('p');
        items.forEach(item => {
            itemsArray.push(item);
        });

        
        if ( itemsArray.length >= 6 ) {
            list.insertAdjacentHTML("beforeend", "<p class='view-more'>More Styles...<span></span></p>");
            for (var i = 0; i < itemsArray.length; i++) {
                if ( i >= 5) {
                    itemsArray[i].classList.add('extra');
                }
            }
        }

    });

    let viewMore = document.querySelectorAll(".view-more");
    viewMore.forEach(link => {        
        if (link) {
            link.addEventListener('click', function (event) {
                if (link.innerHTML == "More Styles...<span></span>") {
                    link.innerHTML = "Show Less<span></span>"
                } else if (link.innerHTML == "Show Less<span></span>") {
                    link.innerHTML = "More Styles...<span></span>"
                }
                let parent = event.target.parentElement;
                let children = parent.querySelectorAll('.extra');
                children.forEach(child => {
                    child.classList.toggle('hide');
                });
            });
        }
    });


}

export default ProductStyles;